// extracted by mini-css-extract-plugin
export default {"container":"otbYHq","doubleSpacing":"vM1HJg","item":"lo63oB","column":"T0vImm"};